import React from 'react';
import Link from 'next/link';
import PropTypes from 'prop-types';
import querystring from 'querystring';
import useQuery from 'utils/hooks/use-query';
import { getSearchUrlPrefix } from 'utils/search';
import { propertyTypeMap, defaultPropertyTypeInfo } from 'utils/property';
import {
  Chevron,
  Count,
  CountWrapper,
  StyledPropertyTypeCount,
  PropertyTypeCountContent,
  CountDescription,
  Plus
} from './styles';

const PropertyTypeCount = ({ propertyType, count, location }) => {
  const query = useQuery(['propertyType', 'page']).asObject;

  const queryAsString =
    Object.keys(query).length > 0 ? `?${querystring.stringify(query)}` : '';
  return (
    <Link
      href={`${getSearchUrlPrefix([location], [propertyType])}${queryAsString}`}
      passHref
    >
      <StyledPropertyTypeCount>
        <PropertyTypeCountContent>
          <CountWrapper>
            {count < 100 ? (
              <Count>{count}</Count>
            ) : (
              <Count>
                {99}
                <Plus />
              </Count>
            )}
          </CountWrapper>
          <CountDescription>
            {`${
              propertyType
                ? propertyTypeMap[propertyType].mainHeading
                : defaultPropertyTypeInfo.mainHeading
            } in `}
            {location.suburb || location.town || location.province}
          </CountDescription>
        </PropertyTypeCountContent>
        <Chevron />
      </StyledPropertyTypeCount>
    </Link>
  );
};

PropertyTypeCount.propTypes = {
  location: PropTypes.object,
  count: PropTypes.number,
  propertyType: PropTypes.string
};

export default React.memo(PropertyTypeCount);
